import {get, post} from './utils';

const dao = {
  queryCreditCard: () =>
    get('/smb-backend/subscription/query-credit-card.action'),
  querySubscriptionDowngrade: solutionType =>
    get('/smb-backend/subscription/query-subscription-downgrade.action', {
      solutionType,
    }),
  queryAddOnsProducts: solutionType =>
    get('/smb-backend/subscription/query-addons-products.action', {
      solutionType,
    }),
  queryAddOnsSets: solutionType =>
    get('/smb-backend/subscription/query-addons-sets.action', {solutionType}),
  listBills: () => get('/smb-backend/subscription/list-bills.action'),
  queryBill: () => get('/smb-backend/subscription/query-bills.action'),
  listPlans: solutionType =>
    get('/smb-backend/subscription/list-plans.action', {solutionType}),
  changePlan: (productId, action, solutionType) =>
    post('/smb-backend/cleverbridge/change-plan.action', {
      productId,
      action,
      solutionType,
    }),
  changeAddOn: (skuQuantity, lookQuantity, action) =>
    post('/smb-backend/cleverbridge/change-addon.action', {
      skuQuantity,
      lookQuantity,
      action,
    }),
  changeAddOns: (solutionType, productId, quantity, action) =>
    post('/smb-backend/cleverbridge/change-addons.action', {
      solutionType,
      productId,
      quantity,
      action,
    }),
  updateRenewalType: (isRenewable, solutionType) =>
    get('/smb-backend/cleverbridge/change-renewal-type.action', {
      isRenewable,
      solutionType,
    }),
  cancelDowngrade: (action, solutionType) =>
    get('/smb-backend/cleverbridge/cancel-downgrade.action', {
      action,
      solutionType,
    }),
  querySubscription: (purchaseId, solutionType) =>
    post('/smb-backend/cleverbridge/query-subscription.action', {
      purchaseId,
      solutionType,
    }),
};

export default dao;
